import React, { type PropsWithChildren } from 'react';

import { QUICK_FIND_PLACEMENT_ID } from '../../../common/utils/post-office-placement/quick-find-banner-placement/constants';
import { QuickFindHeadlessPlacementDataProvider } from '../../../common/utils/post-office-placement/quick-find-banner-placement/headless-placement';
import { useOAuthHandlers } from '../../oauth';
import { useQuickFindBannerPlacementConfig } from './use-config';

export const QuickFindHeadlessBannerProvider = ({
	children,
	isInteracted,
}: PropsWithChildren<{ isInteracted?: boolean }>): React.JSX.Element => {
	const { thirdPartyConfigs, bannerEligibleProductsOrder, shouldMountPlacement } =
		useQuickFindBannerPlacementConfig(isInteracted);

	if (!shouldMountPlacement) {
		return <>{children}</>;
	}

	return (
		<QuickFindHeadlessPlacementDataProvider
			placementId={QUICK_FIND_PLACEMENT_ID}
			thirdPartyConfigs={thirdPartyConfigs}
			availableProductsOrder={bannerEligibleProductsOrder}
			useOAuthHandlers={useOAuthHandlers}
		>
			{children}
		</QuickFindHeadlessPlacementDataProvider>
	);
};
